(function() {
  var dataEl = document.getElementById('delivery-variant-data');
  if (!dataEl) return;
  var variantData = JSON.parse(dataEl.textContent);
  var productLead = parseInt(dataEl.getAttribute('data-product-lead')) || 0;
  var productBuffer = parseInt(dataEl.getAttribute('data-product-buffer')) || 2;

  function skipWeekend(ts) {
    var d = new Date(ts * 1000);
    var dow = d.getDay();
    if (dow === 6) d.setDate(d.getDate() + 2);
    if (dow === 0) d.setDate(d.getDate() + 1);
    return Math.floor(d.getTime() / 1000);
  }

  function getOrdinal(n) {
    var m10 = n % 10, m100 = n % 100;
    if (m100 >= 11 && m100 <= 13) return 'th';
    if (m10 === 1) return 'st';
    if (m10 === 2) return 'nd';
    if (m10 === 3) return 'rd';
    return 'th';
  }

  function formatFull(ts) {
    var d = new Date(ts * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    var dayNum = d.getDate();
    return days[d.getDay()] + ' ' + dayNum + '<sup>' + getOrdinal(dayNum) + '</sup> ' + months[d.getMonth()];
  }

  function formatShort(ts) {
    var d = new Date(ts * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    return d.getDate() + ' ' + months[d.getMonth()];
  }

  function update(variantId) {
    var data = variantData[String(variantId)] || {};
    var lead = (typeof data === 'object' && data.lead > 0) ? data.lead : (typeof data === 'number' && data > 0 ? data : productLead);
    var buffer = (typeof data === 'object' && data.buffer > 0) ? data.buffer : productBuffer;
    if (lead === 0) return;
    var now = Math.floor(Date.now() / 1000);
    var fromTs = skipWeekend(now + (lead * 86400) - 86400);
    var toTs = skipWeekend(fromTs + (buffer * 86400));

    var earliest = document.getElementById('delivery-earliest-inline');
    if (earliest) {
      earliest.innerHTML = '<strong>Earliest Est. Delivery:</strong> ' + formatFull(fromTs);
    }

    var stickyDate = document.querySelector('.sticky-delivery-box__date');
    if (stickyDate) {
      stickyDate.innerHTML = formatFull(fromTs);
    }

    var rangeEl = document.getElementById('delivery-range-main');
    if (rangeEl) {
      rangeEl.innerHTML = 'Estimated delivery date <span>' + formatShort(fromTs) + ' - ' + formatShort(toTs) + '</span>';
    }
  }

  var lastVariant = new URLSearchParams(window.location.search).get('variant');
  setInterval(function() {
    var current = new URLSearchParams(window.location.search).get('variant');
    if (current && current !== lastVariant) {
      lastVariant = current;
      update(current);
    }
  }, 300);
})();